import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Ítem de lista móvil (info, nav o action).
 *
 * Slots: cardTitle, cardBadge, body, cardExtra, cardAmount, cardActions,
 * cardActionsRow, cardRail (contenido del riel derecho; requiere [rail]=true).
 *
 * Modos: Info | Nav (isShortcut) | Action | Rail custom ([rail] + [cardRail]).
 */
@Component({
  selector: 'app-list-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListCardComponent {
  customClass = input<string>('');
  isLoading = input<boolean>(false);
  /**
   * Riel con chevron: usar solo si el tap abre un destino (detalle, viewer).
   * No combinar con CTA primario tipo Subir cuando no hay archivo.
   */
  isShortcut = input<boolean>(false);
  /**
   * Riel derecho centrado (mismo chrome que el chevron) para controls
   * globales de la card (p. ej. checkbox Obligatorio). Mutuamente excluyente
   * con isShortcut: si rail=true se proyecta [cardRail] en lugar del chevron.
   */
  rail = input<boolean>(false);
}
